import { combineReducers } from 'redux';

import {
  SET_EXPORT_STATUS,
  SET_EXPORT_ID,
  EXPORTING_SHOW_EXPORT_MODAL,
  EXPORTING_HIDE_EXPORT_MODAL,
} from '../../actions/exporting/constants';
import createReducer from '../../utils/createReducer';

const exportStatus = createReducer(null, {
  // @ts-expect-error Object is possibly 'undefined'.ts(2532)
  [SET_EXPORT_STATUS]: (draft, { payload }) => payload.status,
});

const exportId = createReducer(null, {
  // @ts-expect-error Object is possibly 'undefined'.ts(2532)
  [SET_EXPORT_ID]: (draft, { payload }) => payload.id,
});

const isShowingExportingModal = createReducer(false, {
  [EXPORTING_SHOW_EXPORT_MODAL]: () => true,
  [EXPORTING_HIDE_EXPORT_MODAL]: () => false,
});

export default combineReducers({
  isShowingExportingModal,
  exportStatus,
  exportId,
});
